export const mainColleague = {
    'loading-title': "ouverture du dossier",
    saved: "Informations du praticien sauvegardées.",
    cancel: {
        label: "perdre vos modifications",
        title: "Annulation", 
		content: "Vous êtes sur le point d'annuler l'ensemble de vos modifications. Vous confirmez ?"
    }
}